/* eslint-disable unused-imports/no-unused-imports */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from "axios"

export module InventoryServiceProxy {
  export class Client {
    private instance: AxiosInstance
    private baseUrl: string
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

    constructor(baseUrl?: string, instance?: AxiosInstance) {
      this.instance = instance ? instance : axios.create()

      this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : ""
    }

    /**
     * Health check endpoint, that checks if backend is in place
     * @return Success
     */
    healthCheck(cancelToken?: CancelToken | undefined): Promise<void> {
      let url_ = this.baseUrl + "/Inventory/HealthCheck"
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {},
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processHealthCheck(_response)
        })
    }

    protected processHealthCheck(response: AxiosResponse): Promise<void> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        return Promise.resolve<void>(null as any)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<void>(null as any)
    }

    /**
     * Get stock for a single SKU in the webshop warehouse (ID:70) subtracting open reservations
     * @return Success
     */
    getWebStockGET(skuId: string | null, cancelToken?: CancelToken | undefined): Promise<number> {
      let url_ = this.baseUrl + "/Inventory/GetWebStock/{skuId}"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetWebStockGET(_response)
        })
    }

    protected processGetWebStockGET(response: AxiosResponse): Promise<number> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        result200 = resultData200 !== undefined ? resultData200 : <any>null

        return Promise.resolve<number>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<number>(null as any)
    }

    /**
     * Get stock for multiple SKU's in the webshop warehouse (ID:70) subtracting open reservations
     * @param body (optional) Table of SKU-id and number of SKUs in stock
     * @return Success
     */
    getWebStockPOST(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number }> {
      let url_ = this.baseUrl + "/Inventory/GetWebStock"
      url_ = url_.replace(/[?&]$/, "")

      const content_ = JSON.stringify(body)

      let options_: AxiosRequestConfig = {
        data: content_,
        method: "POST",
        url: url_,
        headers: {
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetWebStockPOST(_response)
        })
    }

    protected processGetWebStockPOST(response: AxiosResponse): Promise<{ [key: string]: number }> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (resultData200) {
          result200 = {} as any
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key)) (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null
          }
        } else {
          result200 = <any>null
        }
        return Promise.resolve<{ [key: string]: number }>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<{ [key: string]: number }>(null as any)
    }

    /**
     * Get stock in brick and mortar stores for the specific sku
     * @return Success
     */
    getInventoriesWithStoreStock(skuId: string | null, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number }> {
      let url_ = this.baseUrl + "/Inventory/GetInventoriesWithStoreStock/{skuId}"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetInventoriesWithStoreStock(_response)
        })
    }

    protected processGetInventoriesWithStoreStock(response: AxiosResponse): Promise<{ [key: string]: number }> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (resultData200) {
          result200 = {} as any
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key)) (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null
          }
        } else {
          result200 = <any>null
        }
        return Promise.resolve<{ [key: string]: number }>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<{ [key: string]: number }>(null as any)
    }

    /**
     * Creates or renews a reservation for a list of items
     * @param body (optional)
     * @return Success
     */
    createOrRenewReservations(body: ReservationRequest | undefined, cancelToken?: CancelToken | undefined): Promise<ReservationResult[]> {
      let url_ = this.baseUrl + "/Inventory/CreateOrRenewReservations"
      url_ = url_.replace(/[?&]$/, "")

      const content_ = JSON.stringify(body)

      let options_: AxiosRequestConfig = {
        data: content_,
        method: "POST",
        url: url_,
        headers: {
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processCreateOrRenewReservations(_response)
        })
    }

    protected processCreateOrRenewReservations(response: AxiosResponse): Promise<ReservationResult[]> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ReservationResult.fromJS(item))
        } else {
          result200 = <any>null
        }
        return Promise.resolve<ReservationResult[]>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<ReservationResult[]>(null as any)
    }

    /**
     * Gets reservations linked to a specific basket or order
     * @return Success
     */
    getReservationsForOrder(
      reservationId: string | null,
      storeNo: string | null,
      status: number,
      cancelToken?: CancelToken | undefined,
    ): Promise<InventoryRecord[]> {
      let url_ = this.baseUrl + "/Inventory/GetReservationsForOrder/{reservationId}/{storeNo}/{status}"
      if (reservationId === undefined || reservationId === null) throw new Error("The parameter 'reservationId' must be defined.")
      url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId))
      if (storeNo === undefined || storeNo === null) throw new Error("The parameter 'storeNo' must be defined.")
      url_ = url_.replace("{storeNo}", encodeURIComponent("" + storeNo))
      if (status === undefined || status === null) throw new Error("The parameter 'status' must be defined.")
      url_ = url_.replace("{status}", encodeURIComponent("" + status))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetReservationsForOrder(_response)
        })
    }

    protected processGetReservationsForOrder(response: AxiosResponse): Promise<InventoryRecord[]> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(InventoryRecord.fromJS(item))
        } else {
          result200 = <any>null
        }
        return Promise.resolve<InventoryRecord[]>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<InventoryRecord[]>(null as any)
    }

    /**
     * Gets the total remaining quantity for a given product
    and subtracts the reserved quantities from the sum except the quantity related to the specified reservationId
     * @param storeNo (optional) 
     * @return Success
     */
    getInventoryExceptByReservation(
      skuId: string | null,
      reservationId: string | null,
      storeNo: string | null | undefined,
      cancelToken?: CancelToken | undefined,
    ): Promise<number> {
      let url_ = this.baseUrl + "/Inventory/GetInventoryExceptByReservation/{skuId}/{reservationId}?"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      if (reservationId === undefined || reservationId === null) throw new Error("The parameter 'reservationId' must be defined.")
      url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId))
      if (storeNo !== undefined && storeNo !== null) url_ += "storeNo=" + encodeURIComponent("" + storeNo) + "&"
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetInventoryExceptByReservation(_response)
        })
    }

    protected processGetInventoryExceptByReservation(response: AxiosResponse): Promise<number> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        result200 = resultData200 !== undefined ? resultData200 : <any>null

        return Promise.resolve<number>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<number>(null as any)
    }

    /**
     * Updates the inventory with the given updates
     * @param body (optional)
     * @return Success
     */
    updateInventory(body: InventoryRecord[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
      let url_ = this.baseUrl + "/Inventory/UpdateInventory"
      url_ = url_.replace(/[?&]$/, "")

      const content_ = JSON.stringify(body)

      let options_: AxiosRequestConfig = {
        data: content_,
        method: "POST",
        url: url_,
        headers: {
          "Content-Type": "application/json",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processUpdateInventory(_response)
        })
    }

    protected processUpdateInventory(response: AxiosResponse): Promise<void> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        return Promise.resolve<void>(null as any)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<void>(null as any)
    }

    /**
     * Converts stock reservations for an order to actual stock consumption
     * @return Success
     */
    convertReservationsToConsumption(reservationId: string | null, cancelToken?: CancelToken | undefined): Promise<void> {
      let url_ = this.baseUrl + "/Inventory/ConvertReservationsToConsumption/{reservationId}"
      if (reservationId === undefined || reservationId === null) throw new Error("The parameter 'reservationId' must be defined.")
      url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "POST",
        url: url_,
        headers: {},
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processConvertReservationsToConsumption(_response)
        })
    }

    protected processConvertReservationsToConsumption(response: AxiosResponse): Promise<void> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        return Promise.resolve<void>(null as any)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<void>(null as any)
    }

    /**
     * Gets SKU quantity in webshop ignoring reservations
     * @return Success
     */
    getProductQuantity(skuId: string | null, cancelToken?: CancelToken | undefined): Promise<number> {
      let url_ = this.baseUrl + "/Inventory/GetProductQuantity/{skuId}"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetProductQuantity(_response)
        })
    }

    protected processGetProductQuantity(response: AxiosResponse): Promise<number> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        result200 = resultData200 !== undefined ? resultData200 : <any>null

        return Promise.resolve<number>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<number>(null as any)
    }

    /**
     * Gets SKU quantity ignoring reservations in specific store
     * @return Success
     */
    getProductQuantityInStore(skuId: string | null, storeNo: string | null, cancelToken?: CancelToken | undefined): Promise<number> {
      let url_ = this.baseUrl + "/Inventory/GetProductQuantityInStore/{skuId}/{storeNo}"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      if (storeNo === undefined || storeNo === null) throw new Error("The parameter 'storeNo' must be defined.")
      url_ = url_.replace("{storeNo}", encodeURIComponent("" + storeNo))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetProductQuantityInStore(_response)
        })
    }

    protected processGetProductQuantityInStore(response: AxiosResponse): Promise<number> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        result200 = resultData200 !== undefined ? resultData200 : <any>null

        return Promise.resolve<number>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<number>(null as any)
    }

    /**
     * Gets SKU quantity ignoring reservations in all available stores including webstore
     * @return Success
     */
    getInventoryLocations(skuId: string | null, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number }> {
      let url_ = this.baseUrl + "/Inventory/GetInventoryLocations/{skuId}"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetInventoryLocations(_response)
        })
    }

    protected processGetInventoryLocations(response: AxiosResponse): Promise<{ [key: string]: number }> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (resultData200) {
          result200 = {} as any
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key)) (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null
          }
        } else {
          result200 = <any>null
        }
        return Promise.resolve<{ [key: string]: number }>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<{ [key: string]: number }>(null as any)
    }

    /**
     * Gets SKU quantity ignoring reservations in all available stores except webstore
     * @return Success
     */
    getInventoryLocationsExceptWeb(skuId: string | null, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number }> {
      let url_ = this.baseUrl + "/Inventory/GetInventoryLocationsExceptWeb/{skuId}"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetInventoryLocationsExceptWeb(_response)
        })
    }

    protected processGetInventoryLocationsExceptWeb(response: AxiosResponse): Promise<{ [key: string]: number }> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (resultData200) {
          result200 = {} as any
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key)) (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null
          }
        } else {
          result200 = <any>null
        }
        return Promise.resolve<{ [key: string]: number }>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<{ [key: string]: number }>(null as any)
    }

    /**
     * Gets brick and mortar shops that can fulfill all requested items in the requested quantities
     * @param body (optional)
     * @return Success
     */
    getLocationsWithRequestedStockExceptWeb(body: InventoryQuantity[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<string[]> {
      let url_ = this.baseUrl + "/Inventory/GetLocationsWithRequestedStockExceptWeb"
      url_ = url_.replace(/[?&]$/, "")

      const content_ = JSON.stringify(body)

      let options_: AxiosRequestConfig = {
        data: content_,
        method: "POST",
        url: url_,
        headers: {
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetLocationsWithRequestedStockExceptWeb(_response)
        })
    }

    protected processGetLocationsWithRequestedStockExceptWeb(response: AxiosResponse): Promise<string[]> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(item)
        } else {
          result200 = <any>null
        }
        return Promise.resolve<string[]>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<string[]>(null as any)
    }

    /**
     * Gets stock locations that can fulfill any requested items in the requested quantities
     * @param body (optional)
     * @return Success
     */
    getAnyLocationsForMultipleSkusWithRequestedStock(
      body: InventoryQuantity[] | null | undefined,
      cancelToken?: CancelToken | undefined,
    ): Promise<{ [key: string]: { [key: string]: InventoryRecord } }> {
      let url_ = this.baseUrl + "/Inventory/GetAnyLocationsForMultipleSkusWithRequestedStock"
      url_ = url_.replace(/[?&]$/, "")

      const content_ = JSON.stringify(body)

      let options_: AxiosRequestConfig = {
        data: content_,
        method: "POST",
        url: url_,
        headers: {
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetAnyLocationsForMultipleSkusWithRequestedStock(_response)
        })
    }

    protected processGetAnyLocationsForMultipleSkusWithRequestedStock(
      response: AxiosResponse,
    ): Promise<{ [key: string]: { [key: string]: InventoryRecord } }> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (resultData200) {
          result200 = {} as any
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key)) (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : {}
          }
        } else {
          result200 = <any>null
        }
        return Promise.resolve<{
          [key: string]: { [key: string]: InventoryRecord }
        }>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<{
        [key: string]: { [key: string]: InventoryRecord }
      }>(null as any)
    }

    /**
     * Gets ids brick and mortar shops that can fulfill the requested quantity for a specific SKU
     * @param quantity (optional)
     * @return Success
     */
    getStoresWithStock(skuId: string | null, quantity: number | undefined, cancelToken?: CancelToken | undefined): Promise<string[]> {
      let url_ = this.baseUrl + "/Inventory/GetStoresWithStock/{skuId}?"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      if (quantity === null) throw new Error("The parameter 'quantity' cannot be null.")
      else if (quantity !== undefined) url_ += "quantity=" + encodeURIComponent("" + quantity) + "&"
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetStoresWithStock(_response)
        })
    }

    protected processGetStoresWithStock(response: AxiosResponse): Promise<string[]> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(item)
        } else {
          result200 = <any>null
        }
        return Promise.resolve<string[]>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<string[]>(null as any)
    }

    /**
     * Returns amount reserved in specific location
     * @param location (optional) defaults to webstore
     * @return Success
     */
    getOpenReservationsQuantity(skuId: string | null, location: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
      let url_ = this.baseUrl + "/Inventory/GetOpenReservationsQuantity/{skuId}?"
      if (skuId === undefined || skuId === null) throw new Error("The parameter 'skuId' must be defined.")
      url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId))
      if (location !== undefined && location !== null) url_ += "location=" + encodeURIComponent("" + location) + "&"
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processGetOpenReservationsQuantity(_response)
        })
    }

    protected processGetOpenReservationsQuantity(response: AxiosResponse): Promise<number> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        result200 = resultData200 !== undefined ? resultData200 : <any>null

        return Promise.resolve<number>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<number>(null as any)
    }

    /**
     * Reinitializes Inventory Cache from database
     * @return Success
     */
    clearInventoryCache(cancelToken?: CancelToken | undefined): Promise<string> {
      let url_ = this.baseUrl + "/Inventory/ClearInventoryCache"
      url_ = url_.replace(/[?&]$/, "")

      let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
          Accept: "text/plain",
        },
        cancelToken,
      }

      return this.instance
        .request(options_)
        .catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
            return _error.response
          } else {
            throw _error
          }
        })
        .then((_response: AxiosResponse) => {
          return this.processClearInventoryCache(_response)
        })
    }

    protected processClearInventoryCache(response: AxiosResponse): Promise<string> {
      const status = response.status
      let _headers: any = {}
      if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
          if (response.headers.hasOwnProperty(k)) {
            _headers[k] = response.headers[k]
          }
        }
      }
      if (status === 200) {
        const _responseText = response.data
        let result200: any = null
        let resultData200 = _responseText
        result200 = resultData200 !== undefined ? resultData200 : <any>null

        return Promise.resolve<string>(result200)
      } else if (status !== 200 && status !== 204) {
        const _responseText = response.data
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      }
      return Promise.resolve<string>(null as any)
    }
  }

  export class InventoryRecord implements IInventoryRecord {
    productId?: string | undefined
    quantity?: number
    storeNo?: string | undefined

    constructor(data?: IInventoryRecord) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.productId = _data["productId"]
        this.quantity = _data["quantity"]
        this.storeNo = _data["storeNo"]
      }
    }

    static fromJS(data: any): InventoryRecord {
      data = typeof data === "object" ? data : {}
      let result = new InventoryRecord()
      result.init(data)
      return result
    }

    toJSON(data?: any) {
      data = typeof data === "object" ? data : {}
      data["productId"] = this.productId
      data["quantity"] = this.quantity
      data["storeNo"] = this.storeNo
      return data
    }
  }

  export interface IInventoryRecord {
    productId?: string | undefined
    quantity?: number
    storeNo?: string | undefined
  }

  export class ReservationRequest implements IReservationRequest {
    reservationId?: string | undefined
    inventoryRecords?: InventoryRecord[] | undefined
    inventoryLocation?: string | undefined
    status?: number
    reservationInMinutes?: number

    constructor(data?: IReservationRequest) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.reservationId = _data["reservationId"]
        if (Array.isArray(_data["inventoryRecords"])) {
          this.inventoryRecords = [] as any
          for (let item of _data["inventoryRecords"]) this.inventoryRecords!.push(InventoryRecord.fromJS(item))
        }
        this.inventoryLocation = _data["inventoryLocation"]
        this.status = _data["status"]
        this.reservationInMinutes = _data["reservationInMinutes"]
      }
    }

    static fromJS(data: any): ReservationRequest {
      data = typeof data === "object" ? data : {}
      let result = new ReservationRequest()
      result.init(data)
      return result
    }

    toJSON(data?: any) {
      data = typeof data === "object" ? data : {}
      data["reservationId"] = this.reservationId
      if (Array.isArray(this.inventoryRecords)) {
        data["inventoryRecords"] = []
        for (let item of this.inventoryRecords) data["inventoryRecords"].push(item.toJSON())
      }
      data["inventoryLocation"] = this.inventoryLocation
      data["status"] = this.status
      data["reservationInMinutes"] = this.reservationInMinutes
      return data
    }
  }

  export interface IReservationRequest {
    reservationId?: string | undefined
    inventoryRecords?: InventoryRecord[] | undefined
    inventoryLocation?: string | undefined
    status?: number
    reservationInMinutes?: number
  }

  export class ReservationResult implements IReservationResult {
    productId?: string | undefined
    /** Requested quantity */
    quantity?: number
    /** Avaiable to promise = stock minus reservations */
    availableQuantity?: number
    /** Quantity successfully reserved, might be lower than requested */
    currentQuantity?: number
    reservationId?: string | undefined
    status?: number
    isReserved?: boolean

    constructor(data?: IReservationResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.productId = _data["productId"]
        this.quantity = _data["quantity"]
        this.availableQuantity = _data["availableQuantity"]
        this.currentQuantity = _data["currentQuantity"]
        this.reservationId = _data["reservationId"]
        this.status = _data["status"]
        this.isReserved = _data["isReserved"]
      }
    }

    static fromJS(data: any): ReservationResult {
      data = typeof data === "object" ? data : {}
      let result = new ReservationResult()
      result.init(data)
      return result
    }

    toJSON(data?: any) {
      data = typeof data === "object" ? data : {}
      data["productId"] = this.productId
      data["quantity"] = this.quantity
      data["availableQuantity"] = this.availableQuantity
      data["currentQuantity"] = this.currentQuantity
      data["reservationId"] = this.reservationId
      data["status"] = this.status
      data["isReserved"] = this.isReserved
      return data
    }
  }

  export interface IReservationResult {
    productId?: string | undefined
    /** Requested quantity */
    quantity?: number
    /** Avaiable to promise = stock minus reservations */
    availableQuantity?: number
    /** Quantity successfully reserved, might be lower than requested */
    currentQuantity?: number
    reservationId?: string | undefined
    status?: number
    isReserved?: boolean
  }

  export class InventoryQuantity implements IInventoryQuantity {
    productId?: string | undefined
    quantity?: number

    constructor(data?: IInventoryQuantity) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.productId = _data["productId"]
        this.quantity = _data["quantity"]
      }
    }

    static fromJS(data: any): InventoryQuantity {
      data = typeof data === "object" ? data : {}
      let result = new InventoryQuantity()
      result.init(data)
      return result
    }

    toJSON(data?: any) {
      data = typeof data === "object" ? data : {}
      data["productId"] = this.productId
      data["quantity"] = this.quantity
      return data
    }
  }

  export interface IInventoryQuantity {
    productId?: string | undefined
    quantity?: number
  }

  export class ApiException extends Error {
    message: string
    status: number
    response: string
    headers: { [key: string]: any }
    result: any

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
      super()

      this.message = message
      this.status = status
      this.response = response
      this.headers = headers
      this.result = result
    }

    protected isApiException = true

    static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true
    }
  }

  function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): any {
    if (result !== null && result !== undefined) throw result
    else throw new ApiException(message, status, response, headers, null)
  }

  function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true
  }
}
